import agent from '../agent';

const initialState = {
    waste_groups: [],
    eural_codes: [],
    selectedRelation: {
        id: null,
        name: '',
        is_child: false,
        addresses: [],
    },
    collections_history: [],
    waste_groups_object: {
        waste_groups: [],
        requested: false,
    },
};
export const orders = {
    namespaced: true,
    state: initialState,
    getters: {
        // wasteGroups: state => {
        //     return state.waste_groups;
        // },
        // euralCodes: state => {
        //     return state.eural_codes;
        // },
        // collectionsHistory: state => {
        //     return state.collections_history;
        // },
        // selectedRelation: state => {
        //     return state.selectedRelation;
        // }
        waste_groups_object: state => {
            return state.waste_groups_object;
        },
    },
    actions: {
        // setSelectedRelation({ commit }, relation) {
        //     commit('setSelectedRelation', relation)
        //     return Promise.resolve(relation);
        // },
        // getWasteGroups({ commit }) {
        //     return agent.CollectionOrders.getWasteGroups().then(function (response){
        //         commit('getWasteGroups', response.data)
        //         return Promise.resolve(response.data);
        //     }).catch(error => {
        //         commit('getWasteGroupsFailure')
        //         return Promise.reject(error);
        //     });
        // },
        // getEuralCodesByWasteGroup({ commit }, waste_group_id) {
        //     return agent.CollectionOrders.getEuralCodesByWasteGroup(waste_group_id).then(function (response){
        //         commit('getEuralCodes', response.data)
        //         return Promise.resolve(response.data);
        //     }).catch(error => {
        //         commit('getEuralCodesFailure')
        //         return Promise.reject(error);
        //     });
        // },
        // getEuralCodes({ commit }) {
        //     return agent.CollectionOrders.getEuralCodes().then(function (response){
        //         commit('getEuralCodes', response.data)
        //         return Promise.resolve(response.data);
        //     }).catch(error => {
        //         commit('getEuralCodesFailure')
        //         return Promise.reject(error);
        //     });
        // },
        // getCollectionHistory({ commit }, waste_group_id) {
        //     return agent.CollectionOrders.getCollectionHistory(waste_group_id).then(function (response){
        //         commit('getCollectionHistory', response.data)
        //         return Promise.resolve(response.data);
        //     }).catch(error => {
        //         commit('getCollectionHistoryFailure')
        //         return Promise.reject(error);
        //     });
        // },
        getAllWasteGroups({ commit }, params = '') {
            commit('wasteGroupsRequested', true);
            return agent.CollectionWasteGroup.search(params.search || '', params.fields || '')
                .then(response => {
                    commit('setWasteGroups', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        },
    },
    mutations: {
        // getWasteGroups(state, data) {
        //     state.waste_groups = data;
        // },
        // getWasteGroupsFailure(state) {
        //     state.waste_groups = initialState.waste_groups;
        // },
        // getEuralCodes(state, data) {
        //     state.eural_codes = data;
        // },
        // getEuralCodesFailure(state) {
        //     state.eural_codes = initialState.eural_codes;
        // },
        // getCollectionHistory(state, data) {
        //     state.collections_history = data;
        // },
        // getCollectionHistoryFailure(state) {
        //     state.collections_history = initialState.collections_history;
        // },
        // setSelectedRelation(state, relation) {
        //     state.selectedRelation = relation;
        // },
        // setSelectedRelationFailure(state) {
        //     state.selectedRelation = initialState.selectedRelation;
        // },
        setWasteGroups(state, waste_groups) {
            state.waste_groups_object.waste_groups = waste_groups;
        },
        wasteGroupsRequested(state, val) {
            state.waste_groups_object.requested = val;
        },
    },
};
